import { Parallax } from '../components';
import { TwoColumns } from '../components';
/**
 * You can register global components here
 */

const globalComponents = {
  install(Vue) {
    Vue.component(Parallax.name, Parallax);
    Vue.component(TwoColumns.name, TwoColumns);
  }
};

export default globalComponents;
